// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35DoK","col":"styles_col__3YivM"};